import React, { useState, useEffect } from 'react';


import './detail.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomPagination from '../../components/pagination/customPagination';

import { ImLocation2 } from "react-icons/im";


import Badge from 'react-bootstrap/Badge';
import Stack from 'react-bootstrap/Stack';

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

import { IoGlobeOutline } from "react-icons/io5";

import { useNavigate, useParams, useLocation } from "react-router-dom";

import {connect} from 'react-redux';
import * as actions from '../../store/agent/actions';
import config from '../../config/config';


const Agents =({ getAgents, agents }) => {  
    const locationRoute =  useLocation();
    const navigate = useNavigate();
    const [ currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => { 
        await getAgents({page: 1})
    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= agents.pagination.total_pages) {
          setCurrentPage(page);
          let data = {};
            data.page = page;
            data.is_rent = 1;
            getAgents(data).then(res => {
                // console.log()
            });
        }
    };

    console.log('agents', agents)
    if(agents){
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5 text-center bg-dark text-white'>
                <Container>
                    <h1>Agents from Jaipur</h1>
                </Container>
            </section>
            <section className='pt-5 pb-5'>
                {
                    agents && agents.agents && agents.agents.length > 0 && agents.pagination ? 
                        <Container>
                            {
                                agents.agents.map((agent, agentIndex) => {
                                    return <div key={`agent${agentIndex}`} className='card p-3 mb-4 agent'>
                                    <div className='img'>
                                        <img src={`${config.uploadUrl}uploads/agents/${agent.agent_profile_pic}`} />
                                    </div>
                                    <article className='ps-3'>
                                        <h4>{agent.agent_name}</h4>
                                        <h5>{agent.agent_name} <a href='#'><IoGlobeOutline /></a></h5>
                                        <hr/>
                                        <div className='d-flex mt-2 mb-1'>
                                            <span>Recent Project</span>
                                            <Stack direction="horizontal" gap={2} className='ms-4'>
                                                <Badge bg="info">{agent.recent_project}</Badge>
                                                <Badge bg="info">Mahima Group</Badge>
                                                <Badge bg="info">Mahima Group</Badge>
                                                <Badge bg="info">Mahima Group</Badge>
                                            </Stack>
                                        </div>
                                        <hr/>
                                        <Row>
                                            <Col md={6}>
                                                <div className='d-flex mt-2 mb-1'>
                                                    <span>Company Name</span>
                                                    <span className='text-muted ms-3'>{agent.copany_name}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='d-flex mt-2 mb-1'>
                                                    <span>Office address and location:</span>
                                                    <span className='text-muted ms-3'>{agent.office_address}</span>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='d-flex mt-2 mb-1'>
                                                    <span>Certification of services:</span>
                                                    <span className='text-muted ms-3'>{agent.certification_of_services}</span>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className='d-flex mt-2 mb-1'>
                                                    <span>Service Location:</span>
                                                    <span className='text-muted ms-3'><ImLocation2 /> {agent.service_location}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className='mt-2'>
                                            <span>Experience Description:</span>
                                            <p className='text-muted mt-1 mb-0'>{agent.experience_description}</p>
                                        </div>
                                    </article>
                                </div>
                                })
                            }
                            <div className="justify-content-center d-flex">
                            {
                                agents.pagination
                                    ? 
                                    <CustomPagination 
                                        totalPages={agents.pagination.total_pages} 
                                        currentPage={agents.pagination.page} 
                                        onPageChange={handlePageChange} 
                                    />
                                : ''
                            }
                            </div>
                        </Container>
                    : ''
                }
            </section>
        <Footer/>
    </div>
    )
    } else {
        return null;
    }
}
function mapStateToProps(state) {
    
    return {
        agents: state.agent.agents
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          getAgents: (post) => dispatch(actions.getAgents(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Agents);